const practiceStateGetterFunc = ({ data: { practiceState } }) => {
  return {
    practiceState
  };
};

export { practiceStateGetterFunc as practiceStateGetter };
